import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

function HeroIndex() {
  return (
    <div
      className="relative h-[100vh] bg-cover bg-center"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1600428877878-1a0fd85beda8?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
      }}
    >
      <div className="absolute inset-0" style={{ backgroundColor: 'rgba(254, 248, 245, 0.8)' }} />
      
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        className="absolute inset-0 flex items-center justify-center"
      >
        <div className="text-center text-[#7a6e5f] max-w-3xl px-4 font-serif">
          <motion.h1
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.8 }}
            className="text-5xl md:text-6xl font-bold mb-6"
          >
            Skincare that understands you.
          </motion.h1>
          <motion.p
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.8 }}
            className="text-xl mb-8 opacity-80"
          >
            Organic. Personalised. Sustainable. Because your skin deserves more than just a trend.
          </motion.p>
          <motion.div
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.8 }}
            className="flex gap-4 justify-center"
          >
            <Link
              to="/products"
              className="bg-[#809080] text-white px-8 py-3 rounded-md hover:bg-[#6d7d6d] inline-flex items-center"
            >
              Shop Now
              <ArrowRight className="ml-2 w-5 h-5" />
            </Link>
            <Link
              to="/about"
              className="border-2 border-[#809080] text-[#809080] px-8 py-3 rounded-md hover:bg-[#809080] hover:text-white transition-colors"
            >
              Learn More
            </Link>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
}

export default HeroIndex;
